import React, { useState } from "react";
import { Link } from "react-router-dom";

const Menu = (props) => {
  return (
    <>
      <div className="menu">
        <div className="menu_header header_content_container">
          <div className="menu_logo">
            <img
              src="/images/icons/RT_NewHeaderLogo.png"
              alt="RT Logo"
              className="rt_logo"
            />
          </div>
          <div onClick={props.openModal} className="closeModal">
            <img src="/images/icons/close.svg" alt="close" />
          </div>
        </div>

        <div className="menuMain">
          <div
            className="menuMainL position-relative"
            onMouseEnter={props.mouseEnterOnRed}
            onMouseLeave={props.mouseLeaveOnRed}
          >
            <div className="d-flex customGap">
              <ul className="mainPages">
                <li
                  className="colorWhite fw-800"
                  onMouseEnter={props.onMouseEnterSmall}
                  onMouseLeave={props.onMouseLeaveSmall}
                >
                  <a href="/" onClick={props.closeModal}>
                    Home &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="topArrowWhite"
                    />
                  </a>
                </li>
                {/* <li className="colorWhite fw-800"    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}>
                  <a href="/services" onClick={props.closeModal}>
                    Services &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="topArrowWhite"
                    />
                  </a>
                </li> */}
                <li
                  className="colorWhite fw-800"
                  onMouseEnter={props.onMouseEnterSmall}
                  onMouseLeave={props.onMouseLeaveSmall}
                >
                  <a href="/works" onClick={props.closeModal}>
                    Our Work &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="topArrowWhite"
                    />
                  </a>
                </li>
                <li
                  className="colorWhite fw-800"
                  onMouseEnter={props.onMouseEnterSmall}
                  onMouseLeave={props.onMouseLeaveSmall}
                >
                  <a href="/clients" onClick={props.closeModal}>
                    Clients &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="topArrowWhite"
                    />
                  </a>
                </li>
                <li
                  className="colorWhite fw-800"
                  onMouseEnter={props.onMouseEnterSmall}
                  onMouseLeave={props.onMouseLeaveSmall}
                >
                  <a href="/about-us" onClick={props.closeModal}>
                    About Us &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="topArrowWhite"
                    />
                  </a>
                </li>
              </ul>
              <ul>
                <li className="titleWithUnderline colorWhite fw-800">
                  Services
                </li>
                <li className="colorWhite fw-300">
                  <a href="/website-and-mobile/" onClick={props.closeModal}>
                    Web/App
                  </a>
                </li>
                <li className="colorWhite fw-300">
                  <a
                    href="/video-production/"
                    onClick={props.closeModal}
                  >
                    Video Production
                  </a>
                </li>
                <li className="colorWhite fw-300">
                  <a
                    href="/digital-marketing/"
                    onClick={props.closeModal}
                  >
                    Digital Marketing
                  </a>
                </li>
                <li className="colorWhite fw-300">
                  <a href="/Creative-Services" onClick={props.closeModal}>
                    Creative Design
                  </a>
                </li>
                <li className="colorWhite text-white fw-300">
                  <a
                    href="/Digital-Activation-Services"
                    onClick={props.closeModal}
                  >
                    Digital Activations
                  </a>
                </li>
                <li className="colorWhite text-wite fw-300">
                  <a href="/still-photography/" onClick={props.closeModal}>
                    Photography
                  </a>
                </li>
              </ul>
              <ul>
                <li className="titleWithUnderline colorWhite fw-800">
                  Quick Links
                </li>
                <li className="colorWhite fw-300">
                  <a href="/careers" onClick={props.closeModal}>
                    Careers
                  </a>
                </li>
                <li className="colorWhite fw-300">
                {/*  <a href="https://lime-echidna-325677.hostingersite.com/" onClick={props.closeModal}>   */}
                <a href="https://www.reversethought.com/blogs/" onClick={props.closeModal}>
                    Blogs
                  </a>
                  </li>
                <li className="colorWhite fw-300">
                  <a href="/contact-us" onClick={props.closeModal}>
                    Contact Us
                  </a>
                </li>
                <li className="colorWhite fw-300">
                  <a href="/search-by-location" onClick={props.closeModal}>
                    Search By Location
                  </a>
                </li>
              </ul>
              <ul>
                <li className="titleWithUnderline colorWhite fw-800">
                  Connect
                </li>
                <li className="colorWhite fw-300">
                  <Link
                    to="https://www.linkedin.com/company/reverse-thought"
                    target="_blank"
                  >
                    Linkedin
                  </Link>
                </li>
                <li className="colorWhite fw-300">
                  <Link
                    to="https://www.instagram.com/reversethought/"
                    target="_blank"
                  >
                    Instagram
                  </Link>
                </li>
                <li className="colorWhite fw-300">
                  <Link
                    to="https://www.facebook.com/rtcspl/"
                    target="_blank"
                  >
                    Facebook
                  </Link>
                </li>

                <li className="colorWhite fw-300">
                  <a href="https://www.youtube.com/tusharargarg" target="_blank">
                    Youtube
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            className="menuMainR position-relative"
            onMouseEnter={(e) => {
              e.stopPropagation();
              props.mouseEnterOnFooter();
            }}
            onMouseLeave={(e) => {
              e.stopPropagation();
              props.mouseLeaveOnFooter();
            }}
          >
            <a href="/contact-us" className="text-decoration-none">
              {" "}
              <img src="/images/icons/wave-shape.png" alt="wave-shape" />
              <p className="colorWhite fw-800 ">
                Starting a new project <br />
                or want to create an impact on your<br />
                business? <br />
                <span className="fw-800 "> Let’s Connect?</span>
              </p>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Menu;
